import { Link } from 'react-router-dom';
import nawiLogo from "../TravesiaNawi.svg";
import { useLocale } from "../i18n/LocaleContext";

const Header = () => {
    const { locale, setLocale, t } = useLocale();
    return (
        <header className="header">
            <div className="logo">
                <Link to="/" className="logo-container">
                    <img src={nawiLogo} alt="TravesiaNawi logo" className="logo-nawi-logo" />
                    <span className="wordmark">
                        <span className="wordmark-light">Travesia</span><span className="wordmark-heavy">NAWI</span>
                    </span>
                </Link>
            </div>
            <nav className="nav">
                <Link to="/" className="nav-link">{t.nav.home}</Link>
                <Link to="/destinos" className="nav-link">{t.nav.tours}</Link>
                <Link to="/contact" className="nav-link">{t.nav.contact}</Link>
                <div className="lang-toggle" role="group" aria-label="Idioma / Language">
                    <button
                        type="button"
                        className={`lang-toggle-btn${locale === "es" ? " lang-toggle-btn--active" : ""}`}
                        onClick={() => setLocale("es")}
                        aria-pressed={locale === "es"}
                    >ES</button>
                    <button
                        type="button"
                        className={`lang-toggle-btn${locale === "en" ? " lang-toggle-btn--active" : ""}`}
                        onClick={() => setLocale("en")}
                        aria-pressed={locale === "en"}
                    >EN</button>
                </div>
            </nav>
        </header>
    );
};

export default Header;
